import React from 'react';
import Firebase from 'firebase';
import { withRouter } from "react-router-dom";
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';
import Loading from './loading'
export default class main extends React.Component {

    constructor() {
        super();
        this.state = {
            step: 0,
            progress: 0,
            name: "",
            email: "",
            password: "",
            re_password: "",
            ready: true
        }
    }

    componentDidMount() {
        const contex = this;
        var userRef = Firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                var adminRef = Firebase.database().ref("admin_users/" + user.uid).on("value", snap => {
                    if (snap.val().verified) {
                        localStorage.setItem("client_id", snap.val().client_id);
                        localStorage.setItem("uid", user.uid);
                        localStorage.setItem("email", snap.val().email);
                        localStorage.setItem("verified", true);
                        contex.props.history.push("/");
                    } else {
                        contex.setState({ step: 4 })
                    }
                });
            } else {
                contex.setState({ step: 1 })
            }
        });
    }


    componentWillUpdate(nextProps, nextState) {
        if (nextState.step !== this.state.step) {
            switch (nextState.step) {
                case 0:
                    this.setState({ progress: 0 })
                    break;
                case 1:
                    this.setState({ progress: 0 })
                    break;
                case 2:
                    this.setState({ progress: 50 })
                    break;
                case 3:
                    this.setState({ progress: 100 })
                    break;
            }
        }
    }

    renderForm() {
        switch (this.state.step) {
            case 0:
                return (
                    <Loading />
                );
            case 1:
                return (
                    <Step1 callBack={(stp) => {
                        this.setState({ step: stp })
                    }}
                        setValues={(name, email, password, re_password) => {
                            this.setState({
                                name: name,
                                email: email,
                                password: password,
                                re_password: re_password
                            })
                        }}
                        name={this.state.name} email={this.state.email} password={this.state.password} re_password={this.state.re_password}
                    />
                );
            case 2:
                return (
                    <Step2 callBack={(stp) => { this.setState({ step: stp }) }}
                        setData={(client, country) => {
                            this.setState({
                                client: client,
                                country: country
                            })
                        }}
                        client={this.state.client} country={this.state.country}
                    />
                )
            case 3:
                return (
                    <Step3 callBack={(stp) => { this.setState({ step: stp }) }}
                        name={this.state.name}
                        email={this.state.email}
                        password={this.state.password}
                        client={this.state.client}
                        country={this.state.country}
                    />
                )
            case 4:
                return (
                    <Step4 />
                )
        }
    }

    render() {
        return (
            <div className="app flex-row align-items-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="card-group mb-0" style={{ height: "550px" }}>
                                <div className="card p-4">
                                    <div className="card-block">
                                        {this.renderForm()}
                                    </div>
                                </div>
                                <div className="card card-inverse card-primary py-5 d-md-down-none" style={{ width: 44 + '%', backgroundColor: "#006fba" }}>
                                    <div className="card-block text-center">
                                        <div style={{ position: "absolute", top: "25%" }}>
                                            <img src={'/img/logo_blanco.png'} className="img-login" width="90%" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="progress">
                                <div className={"progress-bar w-" + this.state.progress} role="progressbar" style={{ backgroundColor: "#006fba" }} aria-valuenow={this.state.progress} aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/register/main.js